import { render, staticRenderFns } from "./SelectProject.vue?vue&type=template&id=49fd0474&scoped=true&"
import script from "./SelectProject.vue?vue&type=script&lang=js&"
export * from "./SelectProject.vue?vue&type=script&lang=js&"
import style0 from "./SelectProject.vue?vue&type=style&index=0&id=49fd0474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fd0474",
  null
  
)

export default component.exports